import {useState} from 'react';

import {Add, Remove} from '@mui/icons-material';
import {Box, ButtonBase, Collapse, Typography} from '@mui/material';

import {neutral} from '../../../layouts/theme/designSystem';

type InfoDropdownProps = {
  title: string;
  text: string;
};

export const InfoDropdown = ({title, text}: InfoDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box sx={{borderBottom: `1px solid ${neutral[200]}`, py: {xs: 1.5, md: 2}}}>
      <ButtonBase
        onClick={() => setIsOpen((prev) => !prev)}
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          textAlign: 'left',
        }}
      >
        <Typography
          sx={{
            color: neutral['primary-black'],
            fontWeight: 700,
            fontSize: {xs: '1rem', md: '1.25rem'},
            lineHeight: 1.5,
          }}
        >
          {title}
        </Typography>

        <Box sx={{display: 'flex', alignItems: 'center', color: neutral['primary-black']}}>
          {isOpen ? <Remove fontSize='small' /> : <Add fontSize='small' />}
        </Box>
      </ButtonBase>

      <Collapse in={isOpen} timeout={250}>
        <Typography
          sx={{
            mt: 1.5,
            maxWidth: '526px',
            color: neutral['primary-black'],
            fontWeight: 400,
            fontSize: '0.875rem',
            lineHeight: 1.6,
          }}
        >
          {text}
        </Typography>
      </Collapse>
    </Box>
  );
};
